import request from "@/common/request/request";
import {handleRes} from "@vUtils";

interface HandleResInterface {
  success: any,
  fail: any,
}

const resource = {
  getDeviceTypeList: (): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
      const res = await request.GETDeviceType({});
      const result = handleRes(res, {
        failMes: res.msg
      });
      if (result.success) {
        let list = result.success;
        // 兼容 data 直接为数组，或再包一层 data
        if (!Array.isArray(list) && list.data && Array.isArray(list.data)) {
          list = list.data;
        }
        result.success = Array.isArray(list) ? list : false;
      }
      resolve(result);
    });
  },

  getResourceList: (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
      const res = await request.GETResourcePackageList(params);
      const result = handleRes(res, {
        failMes: res.msg
      });
      // handleRes 函数被改了， 不确定影响范围多大， 已经不是预期的判断, 操
      // 业务层调用很多判断都可能出错
      if (result.success && result.success.rows) {
        result.success.rows = result.success.rows || [];
        result.success.total = result.success.total || 0;
      }else {
        result.success = false
      }
      resolve(result);
    });
  },
  addPackage: (params: any): Promise<boolean> => {
    return new Promise(async resolve => {
      const res = await request.POSTResourceAddPackage(params);
      const {fail} = handleRes(res, {
        failMes: res.msg
      });
      resolve(!fail);
    });
  },

  editPackage: (params: any): Promise<boolean> => {
    return new Promise(async resolve => {
      const res = await request.POSTResourceEditPackage(params);
      const {fail} = handleRes(res, {
        failMes: res.msg
      });
      resolve(!fail);
    });
  },



  deletePackage: (params: any): Promise<boolean> => {
    return new Promise(async resolve => {
      const res = await request.POSTResourceDeletePackage(params);
      const {fail} = handleRes(res, {
        failMes: res.msg
      });
      resolve(!fail);
    });
  },

  cancelUpgradeTask: (params: any): Promise<boolean> => {
    return new Promise(async resolve => {
      const res = await request.POSTDeviceUpgradeTaskCancel(params);
      const {fail} = handleRes(res, {
        failMes: res.msg
      });
      resolve(!fail);
    });
  },

  upgradeReset: (params: any): Promise<boolean> => {
    return new Promise(async resolve => {
      const res = await request.POSTDeviceUpgradeReset(params);
      const {fail} = handleRes(res, {
        failMes: res.msg
      });
      resolve(!fail);
    });
  },

  getDescribeList: (params: any): Promise<HandleResInterface> => {
    return new Promise(async resolve => {
      const res = await request.GETDeviceUpgradeDescribeList(params);
      const result = handleRes(res, {
        failMes: res.msg
      });
      if (Array.isArray(result.success)) {
        resolve(result);
      }
      resolve({
        fail: result.fail,
        success: false,
      });
    });
  },

  batchUpgrade: (params: any): Promise<boolean> => {
    return new Promise(async resolve => {
      const res = await request.POSTDeviceBatchUpgrade(params);
      const {fail} = handleRes(res, {
        failMes: res.msg
      });
      resolve(!fail);
    });
  },

  batchIniConfig: (params: any): Promise<boolean> => {
    return new Promise(async resolve => {
      const res = await request.POSTDeviceBatchConfigIni(params);
      const {fail} = handleRes(res, {
        failMes: res.msg
      });
      resolve(!fail);
    });
  },

};

export default resource;
